const config = {
    debug: true,
    server: "https://gptgo.ai",
    accuracyMoneyMathOp: 2
 };

export default config;
